import * as Sentry from '@sentry/browser';

if (import.meta.env.VITE_SENTRY_DSN) {
    const releaseMeta = document.querySelector('meta[name="app-version"]');
    const appRelease = releaseMeta ? releaseMeta.getAttribute('content') : undefined;

    Sentry.init({
        dsn: import.meta.env.VITE_SENTRY_DSN,
        environment: import.meta.env.VITE_SENTRY_ENVIRONMENT || 'production',
        release: appRelease,
        autoSessionTracking: false,        // GlitchTip nie wspiera
        tracesSampleRate: 0,                // performance monitoring off (GlitchTip ma ograniczone wsparcie)
        sendDefaultPii: false,
        denyUrls: [
            /extensions\//i,
            /^chrome:\/\//i,
            /^moz-extension:\/\//i,
            /^safari-extension:\/\//i,
        ],
        ignoreErrors: [
            'ResizeObserver loop limit exceeded',
            'ResizeObserver loop completed with undelivered notifications',
            'Non-Error promise rejection captured',
            // Network errors podczas nawigacji bywają fałszywie alarmujące
            'NetworkError when attempting to fetch resource',
            'AbortError',
            // CSRF refresh / wygaśnięta sesja — to user signal, nie błąd
            /Request failed with status code 419/,
            /CSRF token mismatch/,
            // Browser extensions wstrzykujące do strony
            /^Script error\.?$/,
        ],
        integrations: [
            Sentry.breadcrumbsIntegration({
                console: false,    // nie wysyłaj wszystkiego co poszło na console.log
            }),
        ],
    });

    // User context z meta tagu (renderowane przez @auth w layoutach)
    const userMeta = document.querySelector('meta[name="sentry-user"]');
    if (userMeta) {
        try {
            Sentry.setUser(JSON.parse(userMeta.getAttribute('content')));
        } catch (e) {
            // ignore — meta tag malformed
        }
    }

    window.Sentry = Sentry;
}

import axios from 'axios';
window.axios = axios;

window.axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest';
